import { render } from "./simple_editer.vue?vue&type=template&id=7d4bc633"
import script from "./simple_editer.vue?vue&type=script&lang=js"
export * from "./simple_editer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__